import { Status } from '../../../types';
import { StatusBadge } from '../../base';
import { ButtonGroupField, type ButtonGroupFieldProps } from '../../fields/ButtonGroupField';
import type { FormIncidentsFilter } from '../lib/types';

type StatusFieldProps = Omit<ButtonGroupFieldProps<FormIncidentsFilter, 'status'>, 'name' | 'options'>;

export const StatusField = (props: StatusFieldProps) => (
  <ButtonGroupField
    {...props}
    name='status'
    options={[
      { value: Status.REGISTERED, children: <StatusBadge status={Status.REGISTERED} /> },
      { value: Status.IN_PROGRESS, children: <StatusBadge status={Status.IN_PROGRESS} /> },
      { value: Status.RESOLVED, children: <StatusBadge status={Status.RESOLVED} /> },
    ]}
  />
);
